/**
 * A global namespace for touch events.
 */
const touchEvents = {
  start: "touchstart",
  end: "touchend",
  move: "touchmove",
  cancel: "touchcancel",
};
export default touchEvents;
